export default __webpack_public_path__ + "static/media/hht1_ep17_timeline_q05_a.42eba7ce.png";